import { render, staticRenderFns } from "./view01.vue?vue&type=template&id=fe1fb4a4&scoped=true"
import script from "./view01.vue?vue&type=script&lang=js"
export * from "./view01.vue?vue&type=script&lang=js"
import style0 from "./view01.vue?vue&type=style&index=0&id=fe1fb4a4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1fb4a4",
  null
  
)

export default component.exports